import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const NexaAIContainer = styled(Box)`
  display: flex;
  height: 100vh;
  background-color: ${theme.colors.modalSurface};
  overflow: hidden;
`

export const MainContent = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const Header = styled(Box)`
  height: 80px;
  min-height: 80px;
  flex-shrink: 0;
  padding: 0 ${theme.spacing.medium}px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.colors.surfaceContainerBackground};
  border-bottom: 1px solid ${theme.colors.borderMedium};
`

export const HeaderLeft = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.small}px;
`

export const HeaderTitle = styled.span`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.xxxLarge};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.menuItemText};
`

export const ThreadInfoBar = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background-color: ${theme.colors.modalSurface};
`

export const ThreadTitle = styled.span`
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 14px;
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.textSecondary};
  line-height: 22px;
`

export const BetaTag = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 22px;
  margin-left: 12px;
  padding: 4px 8px;
  background-color: #debdd9;
  border-radius: 6px;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: 12px;
  font-weight: 600;
  color: #292128;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-align: center;
`

export const ThreadMenuButton = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: 1px solid ${theme.colors.dropdownBorder};
  border-radius: 12px;
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.surfaceItemBackgroundLow};
  }

  html[data-theme='light'] & {
    &:hover {
      background-color: ${theme.colors.cardFillTertiary};
      color: ${theme.colors.menuItemText};
    }
  }
`
